import { render, staticRenderFns } from "./ItemMenu.vue?vue&type=template&id=70ea55f4&scoped=true&"
import script from "./ItemMenu.vue?vue&type=script&lang=js&"
export * from "./ItemMenu.vue?vue&type=script&lang=js&"
import style0 from "./ItemMenu.vue?vue&type=style&index=0&id=70ea55f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ea55f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VList,VListItem,VListItemTitle,VMenu})
